import React from 'react'
import { withTranslation } from 'react-i18next'
import { inject, observer } from 'mobx-react'
import { startProCheckout } from '../../proCheckout'
import { HugeiconsIcon } from '@hugeicons/react'
import { Folder01Icon, ArrowRight01Icon } from '@hugeicons/core-free-icons'
import Icon from '../common/Icon'
import EyeIcon from '../common/icons/EyeIcon'

const SAMPLE_GROUPS = [
  {
    name: 'West Territory',
    expanded: true,
    items: ['Daniel Alcides Carr...', 'Ground Terminal Cer...', 'Heydariyeh Industri...', 'RE COFFEE', 'La Cafeseria Specia...']
  },
  { name: 'Northwestern Territory', items: [] },
  { name: 'East Territory', items: [] }
]

const SampleGroup = ({ group }) => (
  <li className='target-group'>
    <div className='target-group__btn-wrapper'>
      <div className='target-group__chev-holder'>
        <HugeiconsIcon
          icon={ArrowRight01Icon}
          size={16}
          color='#64748B'
          className={`target-group__chev${group.expanded ? ' target-group__chev--expanded' : ''}`}
        />
      </div>
      <div className='target-group__btn'>
        <HugeiconsIcon icon={Folder01Icon} size={18} color='#334155' className='target-group__folder-icon' />
        <span className='target-group__name-holder'>
          <span className='target-group__name'>{group.name}</span>
        </span>
        <span className='target-group__controls'>
          <div className='toggle right-toggle no-padding target-group__icon target-group__dots'>
            <Icon id='three-dots' />
          </div>
          <EyeIcon className='target-group__eye' />
        </span>
      </div>
    </div>
    {group.expanded && (
      <ul className='item-list'>
        {group.items.map(name => (
          <li key={name} className='item-list__item'>
            <div className='item-list__btn' style={{ '--icon-color': '#F97316' }}>
              <Icon extraClasses={['item-list__icon']} id='map-marker-icon' />
              <span className='item-list__text'>{name}</span>
              <Icon id='three-dots' className='three' />
            </div>
          </li>
        ))}
      </ul>
    )}
  </li>
)

const UpgradeToPro = ({ t, uiStore }) => {
  const handleUpgradeClick = async (e) => {
    e.preventDefault()
    await startProCheckout({ uiStore, t })
  }

  return (
    <div className='upgrade'>
      <div className='upgrade__background'>
        <ul className='upgrade__preview' aria-hidden='true'>
          {SAMPLE_GROUPS.map(group => <SampleGroup key={group.name} group={group} />)}
        </ul>
      </div>

      <div className='upgrade__card'>
        <div className='upgrade__card-title'>Your saved work lives here</div>
        <div className='upgrade__card-desc'>
          Upgrade to Pro to save and export territories and locations in folders, using full population and income data.
        </div>
        <a className='upgrade__btn' onClick={handleUpgradeClick}>
          Upgrade to Pro
        </a>
      </div>
    </div>
  )
}

export default withTranslation()(inject('uiStore')(observer(UpgradeToPro)))
